import { Store } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Chip, Grid, Typography } from '@mui/material';
import React from 'react';
import { getRoleName, getRoleColor } from '../pages/settings/hooks/userRoles';

export const StoreCard = ({ type, storeName, storeid, address, cardActionHandler }) => {
    // Get role name and color from centralized role configuration
    const roleName = getRoleName(type);
    const roleColor = getRoleColor(type);

    return (
        <Grid item key={storeName}>
            <Card xs={2} elevation={6}>
                <CardActionArea 
                    onClick={() => cardActionHandler(type, storeid)}
                    sx={{ paddingTop: 1 }}
                >
                    <center>
                        <Chip 
                            size="small" 
                            label={roleName} 
                            style={{ 
                                borderColor: roleColor, 
                                color: roleColor,
                                fontWeight: 'bold'
                            }} 
                            variant="outlined" 
                        />
                    </center>
                    <Box sx={{ padding: 0.5 }} />
                    <center>
                        <Store sx={{ textAlign: 'center', fontSize: '120px' }} />
                    </center>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {storeName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {storeid} <br />
                            {address} <br />
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
}